'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CommunityVideoPlayer = require('../../CommunityVideoPlayer');

var _CommunityVideoPlayer2 = _interopRequireDefault(_CommunityVideoPlayer);

var _Uniform = require('../../Uniform');

var _FollowUserLink = require('../FollowUserLink');

var _FollowUserLink2 = _interopRequireDefault(_FollowUserLink);

var _communityContentType = require('../../../shared/community-content-type');

var _communityContentType2 = _interopRequireDefault(_communityContentType);

var _propTypes = require('../../../shared/prop-types');

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

var _urls = require('../../../utils/urls');

var _urls2 = _interopRequireDefault(_urls);

var _getHighestQualityVideoUrl = require('../../../utils/getHighestQualityVideoUrl');

var _getHighestQualityVideoUrl2 = _interopRequireDefault(_getHighestQualityVideoUrl);

var _mobileUtil = require('../../../utils/mobile-util');

var _mobileUtil2 = _interopRequireDefault(_mobileUtil);

var _generatePlayerId = require('../../../utils/generatePlayerId');

var _generatePlayerId2 = _interopRequireDefault(_generatePlayerId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SharedVideo = function (_PureComponent) {
  _inherits(SharedVideo, _PureComponent);

  function SharedVideo(props) {
    _classCallCheck(this, SharedVideo);

    var _this = _possibleConstructorReturn(this, (SharedVideo.__proto__ || Object.getPrototypeOf(SharedVideo)).call(this, props));

    _this.onClick = function () {
      var thumbnailWidth = _this.refs.container.getBoundingClientRect().width;
      var aspectRatio = 9 / 16;
      var thumbnailHeight = thumbnailWidth * aspectRatio;

      if (_this.hasImmersiveView()) {
        var videoUrl = (0, _getHighestQualityVideoUrl2.default)(_this.props.videoFiles);
        _this.setState({
          isPlaying: true,
          embedHeight: thumbnailHeight + 'px',
          videoSource: videoUrl
        });
      } else if (_this.state.isEmbedded) {
        // Handle embedded videos
        var videoSrc = (0, _urijs2.default)(_urls2.default.getCommunityContentEmbedUrl(_this.props.communityContentId.relatedId, true));

        if (_this.props.forcePublicView) {
          videoSrc.addQuery('forcePublicView', 'true');
        }
        videoSrc.addQuery('isTimeline', 'true');

        _this.setState({
          isPlaying: true,
          embedHeight: thumbnailHeight + 'px',
          videoSource: videoSrc.toString()
        });
      } else {
        // Handle older videos with no community content ID
        var _videoUrl = (0, _getHighestQualityVideoUrl2.default)(_this.props.videoFiles);
        _this.setState({
          isPlaying: true,
          embedHeight: thumbnailHeight + 'px',
          videoSource: _videoUrl
        });
      }
    };

    _this.onVideoOverlayClick = function () {
      // We only support desktop browsers for theatre view right now
      if (_this.hasImmersiveView()) {
        if (!_this.useVideoInterface()) {
          _this.setState({ isPlaying: false });
        }
        _this.props.onVideoOverlayClick();
      }
    };

    var isEmbedded = props.communityContentId && props.communityContentId.relatedId && props.communityContentId.type === _communityContentType2.default.PerformanceCenter;

    _this.state = {
      isEmbedded: isEmbedded,
      playerId: (0, _generatePlayerId2.default)(props.feedContentId)
    };
    return _this;
  }

  _createClass(SharedVideo, [{
    key: 'hasImmersiveView',
    value: function hasImmersiveView() {
      return this.props.onVideoOverlayClick && !_mobileUtil2.default.isMobileOrTablet();
    }
  }, {
    key: 'useVideoInterface',
    value: function useVideoInterface() {
      return !_mobileUtil2.default.isMobileOrTablet();
    }
  }, {
    key: 'renderPreview',
    value: function renderPreview() {
      if (this.state.isPlaying) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'video-container', ref: 'container', onClick: this.onClick },
        _react2.default.createElement(
          'div',
          { className: 'video-thumb-overlay' },
          _react2.default.createElement(
            'div',
            { className: 'play-video' },
            _react2.default.createElement(_Uniform.Icon, { type: 'play' })
          )
        ),
        _react2.default.createElement('img', { className: 'video-thumbnail', src: this.props.thumbnail.url })
      );
    }
  }, {
    key: 'renderVideo',
    value: function renderVideo() {
      if (!this.state.isPlaying) return null;

      if (this.useVideoInterface()) {
        var _props = this.props,
            adTag = _props.adTag,
            communityContentId = _props.communityContentId,
            durationMs = _props.durationMs,
            logData = _props.logData;

        var playables = [{ communityContentId: communityContentId, src: this.state.videoSource }];

        return _react2.default.createElement(
          'div',
          { className: 'embeddable-video', style: this.state.embedHeight ? { height: this.state.embedHeight } : null },
          _react2.default.createElement(_CommunityVideoPlayer2.default, {
            adTag: adTag,
            autoplay: true,
            durationMs: durationMs,
            logData: logData,
            muted: true,
            playables: playables,
            playerId: this.state.playerId,
            onVideoOverlayClick: this.onVideoOverlayClick })
        );
      } else if (this.state.isEmbedded) {
        // React 15 doesn't support 'allow' attribute so dangerouslySetInnerHTML is a away around it.
        var iframe = {
          __html: '<iframe\n        src="' + this.state.videoSource + '"\n        width="400"\n        height="225"\n        allow="autoplay; fullscreen"\n        allowFullscreen>\n      </iframe>'
        };

        return _react2.default.createElement('div', { className: 'embeddable-video',
          style: this.state.embedHeight ? { height: this.state.embedHeight } : null,
          dangerouslySetInnerHTML: iframe });
      }

      return _react2.default.createElement(
        'div',
        { className: 'video-player' },
        _react2.default.createElement('video', { autoPlay: true, controls: true, src: this.state.videoSource })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _Uniform.CardMedia,
          null,
          _react2.default.createElement(
            'div',
            { className: 'media-container' },
            this.renderPreview(),
            this.renderVideo()
          )
        ),
        !!this.props.title && _react2.default.createElement(
          'div',
          { className: 'content-description' },
          !!this.props.title ? _react2.default.createElement(
            _Uniform.Subhead,
            { className: 'uni-margin--one--top' },
            this.props.title
          ) : null,
          !!this.props.subtitle ? _react2.default.createElement(
            _Uniform.Text,
            { level: 'small', color: 'subtle', isTight: true, className: 'uni-margin--half--top' },
            this.props.subtitle
          ) : null
        ),
        this.props.includeFollowButton && this.props.relatedFeedUser && _react2.default.createElement(_FollowUserLink2.default, {
          currentUserId: this.props.currentUserId,
          feedUser: this.props.relatedFeedUser
        })
      );
    }
  }]);

  return SharedVideo;
}(_react.PureComponent);

SharedVideo.propTypes = {
  adTag: _propTypes.adTagShape,
  communityContentId: _propTypes.CommunityContentId,
  currentUserId: _react.PropTypes.string,
  durationMs: _react.PropTypes.number,
  feedContentId: _react.PropTypes.string.isRequired,
  forcePublicView: _react.PropTypes.bool,
  includeFollowButton: _react.PropTypes.bool,
  logData: _react.PropTypes.object,
  onVideoOverlayClick: _react.PropTypes.func,
  relatedFeedUser: _propTypes.FeedUser,
  subtitle: _react.PropTypes.string,
  thumbnail: _react.PropTypes.shape({
    url: _react.PropTypes.string.isRequired
  }).isRequired,
  title: _react.PropTypes.string,
  videoFiles: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    quality: _react.PropTypes.number,
    url: _react.PropTypes.string
  }))
};
SharedVideo.contextTypes = {
  store: _react.PropTypes.object.isRequired
};
exports.default = SharedVideo;